import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`text-center relative`};
`
export const Main = styled.div`
  ${tw`inline-flex mx-auto py-8`};
  overflow-y: auto;
  overscroll-behavior: auto contain;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;

  &::before,
  &::after {
    content: '';
    ${tw`absolute z-10 top-0 h-full w-8 pointer-events-none`};
  }

  &::before {
    ${tw`left-0`};
    background: linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  }

  &::after {
    ${tw`right-0`};
    background: linear-gradient(-90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  }
`

export const Tag = styled.a`
  ${tw`py-1 px-8 flex flex-shrink-0 items-center cursor-pointer no-underline`};
  border-right: 1px solid var(--color-grey);

  &:last-child,
  &:last-of-type {
    border-right: 0;
  }
`

export const TagImageWrapper = styled.div`
  ${tw`relative`};
`

export const TagImage = styled.div`
  ${tw`block mx-auto rounded-full mr-3 overflow-hidden`};
  width: 48px;
  height: 48px;
  object-fit: cover;
`

export const TagImageBorder = styled.svg`
  @keyframes stroke {
    to {
      stroke-dashoffset: 0;
    }
  }

  ${tw`absolute top-0 left-0`};
  transform: rotate(-90deg) scale(1.085);
  stroke-dasharray: 145;
  stroke-dashoffset: 145;
  opacity: 0;
  transition: opacity 0.3s;
  stroke: var(--color-gold);

  ${Tag}:hover & {
    animation: stroke 0.3s cubic-bezier(0, 0.13, 1, 0.87) forwards;
    opacity: 1;
  }
`

export const TagTitle = styled.div`
  &:hover {
    color: var(--color-gold) !important;
  }
`
